// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__8O05h","formControl":"addForm_formControl__iWTxp","list":"addForm_list__YYSEA","btnWrpper":"addForm_btnWrpper__9LhEU"};